export interface HeroStat {
  value: string;
  label: string;
  detail?: string;
}

export interface FeatureHighlight {
  id: string;
  eyebrow: string;
  title: string;
  description: string;
  impact: string;
}

export interface FeedPreviewCard {
  id: string;
  status: string;
  title: string;
  venue: string;
  time: string;
  distance: string;
  tags: string[];
}

export interface MapPin {
  id: string;
  label: string;
  top: string;
  left: string;
  heat: "hot" | "warm" | "rising";
}

export interface ProductLoopStep {
  id: string;
  step: string;
  title: string;
  description: string;
}

export interface BenefitPillar {
  id: string;
  title: string;
  description: string;
}

export const heroStats: HeroStat[] = [
  {
    value: "LiveMap",
    label: "mapa de calor para revelar concentração e atividade da cidade",
  },
  {
    value: "Grupo do evento",
    label: "conversa em grupo para combinar, comentar e viver o rolê junto",
  },
  {
    value: "Instagram Stories",
    label: "Compartilhe nos Stories em segundos.",
    detail: "O evento sai do app com narrativa visual e alcance social imediato.",
  },
  {
    value: "Até 70 km",
    label: "descoberta em lista e mapa guiada por localização",
  },
];

export const featureHighlights: FeatureHighlight[] = [
  {
    id: "livemap",
    eyebrow: "Destaque visual",
    title: "LiveMap com mapa de calor",
    description:
      "A parte mais marcante do app mostra onde a cidade está aquecendo e ajuda você a bater o olho no que vale abrir agora.",
    impact: "Leitura imediata do que está puxando atenção.",
  },
  {
    id: "chat",
    eyebrow: "Contexto social",
    title: "Conversa em grupo dentro do evento",
    description:
      "Cada evento pode virar um grupo em tempo real para combinar, comentar e entrar no clima com quem vai estar lá.",
    impact: "Mais interação antes, durante e depois do rolê.",
  },
  {
    id: "radius",
    eyebrow: "Descoberta geográfica",
    title: "Lista + mapa com raio configurável",
    description:
      "O usuário pode navegar em feed ou mapa e puxar eventos e estabelecimentos por proximidade em um raio de até 70 km.",
    impact: "Experiência flexível para descoberta rápida e decisão local.",
  },
];

export const feedPreviewCards: FeedPreviewCard[] = [
  {
    id: "rooftop",
    status: "Bombando agora",
    title: "Neon Rooftop Session",
    venue: "Mirante 210",
    time: "Hoje, 23:30",
    distance: "2,4 km",
    tags: ["Lista", "Mapa", "House"],
  },
  {
    id: "samba",
    status: "Grupo ativo",
    title: "Samba no Centro",
    venue: "Pátio Aurora",
    time: "Em 35 min",
    distance: "5,8 km",
    tags: ["Grupo aberto", "Ao vivo", "Stories"],
  },
  {
    id: "indie",
    status: "Aquecendo",
    title: "After Indie Club",
    venue: "Distrito 18",
    time: "Hoje, 01:00",
    distance: "14 km",
    tags: ["Radar local", "Noite", "Pins"],
  },
];

export const mapPins: MapPin[] = [
  {
    id: "pin-1",
    label: "Centro",
    top: "18%",
    left: "62%",
    heat: "hot",
  },
  {
    id: "pin-2",
    label: "Batel",
    top: "34%",
    left: "34%",
    heat: "warm",
  },
  {
    id: "pin-3",
    label: "After",
    top: "54%",
    left: "68%",
    heat: "hot",
  },
  {
    id: "pin-4",
    label: "Indie",
    top: "66%",
    left: "26%",
    heat: "rising",
  },
];

export const productLoopSteps: ProductLoopStep[] = [
  {
    id: "discover",
    step: "01",
    title: "Descobre no feed ou no mapa",
    description:
      "A entrada pode acontecer pela visualização em lista, pelo mapa ou pelo LiveMap.",
  },
  {
    id: "engage",
    step: "02",
    title: "Entra no grupo do evento",
    description:
      "A conversa continua dentro do grupo do próprio evento, sem tirar a galera do app.",
  },
  {
    id: "share",
    step: "03",
    title: "Compartilha nos Stories",
    description:
      "O mesmo evento vira compartilhamento visual, reforçando descoberta e vontade de ir.",
  },
];

export const benefitPillars: BenefitPillar[] = [
  {
    id: "retention",
    title: "Descubra mais rápido",
    description:
      "Abra o app e veja o que está bombando perto de você sem perder tempo rolando feed genérico.",
  },
  {
    id: "social",
    title: "Entre no clima do evento",
    description:
      "O grupo do evento ajuda a combinar, reagir e sentir a energia do rolê antes mesmo de chegar.",
  },
  {
    id: "distribution",
    title: "Compartilhe com um toque",
    description:
      "Stories e compartilhamento fazem cada evento circular mais e chegar mais longe entre amigos.",
  },
];
